import type { Resource } from '@toolproof-core/genesis/_contract/_index';

import type { RoleDirection } from '@/workflow/_contract/role';

export function getProjectionRecord(resource: Resource): Record<string, unknown> | null {
    const projection = resource.projection;
    if (projection === null || typeof projection !== 'object') return null;
    return projection as Record<string, unknown>;
}

export function getProjectionHandle<THandle extends string>(resource: Resource): THandle | null {
    const projection = getProjectionRecord(resource);
    if (!projection) return null;

    const handle = projection.handle;
    return typeof handle === 'string' && handle.length > 0 ? (handle as THandle) : null;
}

export function getToolHandle(resource: Resource): string | null {
    return getProjectionHandle<string>(resource);
}

export function getRoleEntriesByDirection(
    resource: Resource,
    direction: RoleDirection
): Array<[string, unknown]> {
    const projection = getProjectionRecord(resource);
    if (!projection) return [];

    const roleSpec = projection.roleSpec;
    if (roleSpec === null || typeof roleSpec !== 'object') return [];

    const roleSpecRecord = roleSpec as Record<string, unknown>;
    const key = direction === 'input' ? 'inputRoleByName' : 'outputRoleByName';
    const roleByName = roleSpecRecord[key];
    if (roleByName === null || typeof roleByName !== 'object') return [];

    return Object.entries(roleByName as Record<string, unknown>);
}
